module.exports = __webpack_public_path__ + "static/media/menu.2da5f26b.svg";